import React, { useState, useEffect, useCallback } from 'react';
import { Form, Input, Button, Card, message, Typography, Row, Col } from 'antd';
import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { login, getCaptcha } from '../../services/api';
import { setToken, setUser } from '../../utils/auth';

const { Title } = Typography;

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [captchaSvg, setCaptchaSvg] = useState('');
  const [captchaId, setCaptchaId] = useState('');
  const navigate = useNavigate();

  const loadCaptcha = useCallback(async () => {
    try {
      const res = await getCaptcha();
      setCaptchaSvg(res.data.svg);
      setCaptchaId(res.data.captchaId);
    } catch {
      // 忽略验证码加载失败
    }
  }, []);

  useEffect(() => {
    loadCaptcha();
  }, [loadCaptcha]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await login({ ...values, captchaId, captchaCode: values.captchaCode });
      setToken(res.data.token);
      setUser(res.data.user);
      message.success(res.message);
      navigate('/', { replace: true });
    } catch (err) {
      loadCaptcha();
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#f0f2f5' }}>
      <Card style={{ width: 400, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: 32,color: '#1890ff' }}>恒力源数字驾驶舱（BI）</Title>
        <Form onFinish={onFinish} size="large">
          <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input prefix={<UserOutlined />} placeholder="用户名" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>
          <Form.Item name="captchaCode" rules={[{ required: true, message: '请输入验证码' }]}>
            <Row gutter={8} align="middle" wrap={false}>
              <Col flex="1 1 0%">
                <Input prefix={<SafetyOutlined />} placeholder="验证码" />
              </Col>
              <Col flex="0 0 auto">
                {captchaSvg && (
                  <img
                    src={`data:image/svg+xml,${encodeURIComponent(captchaSvg)}`}
                    alt="验证码"
                    onClick={loadCaptcha}
                    style={{ cursor: 'pointer', height: 38, borderRadius: 4, display: 'block' }}
                  />
                )}
              </Col>
            </Row>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>登 录</Button>
          </Form.Item>
        </Form>
      </Card>
      <div style={{ position: 'fixed', bottom: 16, width: '100%', textAlign: 'center', color: '#999', fontSize: 12 }}>
        BI 系统 v1.0.0 Powered by 贵州恒力源集团信息技术部
      </div>
    </div>
  );
}
